import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Atividade } from 'src/app/core/atividade';

import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';


@Component({
  selector: 'listar-oficinas',
  templateUrl: './listar-oficinas.component.html',
  styleUrls: ['./listar-oficinas.component.css']
})
export class ListarOficinasComponent implements OnInit {

  @Input() oficinas: Atividade[];
  @Output() onAtualizarOficina = new EventEmitter();
  @Output() onAdicionar = new EventEmitter();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  mostrarTabela = false;
  msg: string;

  displayedColumns: string[] = ['descricao', 'datainicio','horario', 'datafim', 'maxparticipantes', 'projeto', 'acoes'];
  dataSource: MatTableDataSource<Atividade> = new MatTableDataSource();

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  constructor(private activatedRoute: ActivatedRoute, private router: Router) { }
  menu: string;
  area: string;
  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

    this.dataSource.paginator = this.paginator;
    this.area = this.getArea();
    this.carregarLista();
  }

  getMenu(): string {
    const primeiroSegmento = this.router.url.split('/')[1];
    return primeiroSegmento.startsWith('menu') ? primeiroSegmento : undefined;
  }

  private getArea(): string {
    this.menu = this.getMenu();
    return this.menu && this.menu == "menu-sap" ? 'S' : (this.menu && this.menu == "menu-pedagogico" ? 'P' : null);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["oficinas"] && !_.isEmpty(changes["oficinas"].currentValue)) {
      this.carregarLista();
    }
  }


  carregarLista() {
      if (_.isEmpty(this.oficinas)) {
        this.mostrarTabela = false;
        this.msg = 'Nenhuma oficina cadastrada.';
      } else {
        this.oficinas.forEach(atividade => {
          atividade.area = this.area;
        })
        this.dataSource.data = this.oficinas;
        this.mostrarTabela = true;
    }
  }

  deletar(oficina: any): void {
    const index = this.oficinas.indexOf( this.oficinas.find(col => col === oficina));
    if (index >= 0) {
      this.oficinas.splice(index, 1);
      this.carregarLista();
    }
  }

  atualizar(oficina: Atividade) {
    oficina.area =this.area;
    this.onAtualizarOficina.emit(oficina);
  }
  
  novo() {
    this.onAdicionar.emit(true);
  }

}
